import { ENV } from '@/lib/config/env';

export const FLOW_DIGEST_AGENT_ID = 'flow-digest-agent';

/**
 * Builds the Flow Digest URL from PLATFORM_BASE_URL with workspaceId as query param.
 * e.g. https://dev.monksflow.ai -> https://flow-digest.dev.monksflow.ai?workspaceId={workspaceId}
 *      https://monksflow.ai     -> https://flow-digest.monksflow.ai?workspaceId={workspaceId}
 */
const getFlowDigestUrl = (workspaceId: string): string => {
  const { hostname, protocol } = new URL(ENV.PLATFORM_BASE_URL);
  const base = `${protocol}//flow-digest.${hostname}`;
  const params = new URLSearchParams({ workspaceId });
  return `${base}?${params.toString()}`;
};

/**
 * Opens the Flow Digest tool in a new browser tab.
 */
export const openFlowDigestTool = (workspaceId: string): void => {
  window.open(getFlowDigestUrl(workspaceId), '_blank');
};
